__turbopack_context__.v({
  "addBtn": "Filters-module__48C0aW__addBtn",
  "checkmark": "Filters-module__48C0aW__checkmark",
  "chip": "Filters-module__48C0aW__chip",
  "chipLabel": "Filters-module__48C0aW__chipLabel",
  "chipRemove": "Filters-module__48C0aW__chipRemove",
  "default": "Filters-module__48C0aW__default",
  "divider": "Filters-module__48C0aW__divider",
  "empty": "Filters-module__48C0aW__empty",
  "groupDivider": "Filters-module__48C0aW__groupDivider",
  "groupLabel": "Filters-module__48C0aW__groupLabel",
  "item": "Filters-module__48C0aW__item",
  "itemActive": "Filters-module__48C0aW__itemActive",
  "lg": "Filters-module__48C0aW__lg",
  "optionIcon": "Filters-module__48C0aW__optionIcon",
  "optionsList": "Filters-module__48C0aW__optionsList",
  "popup": "Filters-module__48C0aW__popup",
  "root": "Filters-module__48C0aW__root",
  "searchInput": "Filters-module__48C0aW__searchInput",
  "searchRow": "Filters-module__48C0aW__searchRow",
  "segment": "Filters-module__48C0aW__segment",
  "segmentInput": "Filters-module__48C0aW__segmentInput",
  "shortcutBadge": "Filters-module__48C0aW__shortcutBadge",
  "sm": "Filters-module__48C0aW__sm",
  "valueIcons": "Filters-module__48C0aW__valueIcons",
  "valuePopup": "Filters-module__48C0aW__valuePopup",
});
